import FetchData from "../hook/fetchData";

function getExtension(file){
  if (!file) return "";

  const parts = file.split(".");
  return parts.length > 1 ? parts.pop().toLowerCase() : "";
};

export const uploadToS3 =async(Id,folder,fileToUpload,fileType) => {
         const Body = JSON.stringify({
            folder:folder,
            name:`${Id}.${getExtension(fileToUpload.name)}`,
            type:fileType
         })
        const response = await FetchData({
            method: 'POST',
            endPoint: 'uploadtos3',
            body:Body
        })
        const url = response.data.url;
        const success = response.data.success;
        const path = response.data.path;
        const message = response.data.message;
        if(Boolean(success))
        {
           const result= await fetch(url, {
                method: "PUT",
                headers: {
                    "Content-Type": fileType,
                },
                body: fileToUpload, 
            });
            if (result.ok)
                return `https://sgltools.s3.ca-central-1.amazonaws.com/${path}`;

        }
        return '';
    }

 export const handleFile = (event,setProfile,setFileToUpload,setFileType,error) => {
       
        const file = event.target.files[0]; // Access the first selected file
        if (file) {
            const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg';
           
            if (!isJpgOrPng) {
                error('You can only upload JPG/PNG file!');
            }
            else {
                const reader = new FileReader();

                reader.onloadend = () => {
                    // reader.result will contain the data URL (e.g., data:image/jpeg;base64,...)
                    const base64String = reader.result;
                    setProfile(base64String);
                };

                reader.readAsDataURL(file);

                setFileToUpload(file);
                setFileType(file.type);
            }
        }
    };
   